<div [formGroup]="assetItemForm">
  <div class="asset-upload-stack">
    <div class="asset-dropzone" [ngClass]="{'dropped-area': fileIsOver, 'hoverable': !readOnly}"
      (dragover)="$event.preventDefault(); fileIsOver = true" (dragleave)="fileIsOver = false"
      (drop)="$event.preventDefault(); fileIsOver = false; onFileDrop($event)"
      (click)="readOnly ? null : selectFile()">
      <div class="dropzone-icon">
        <mat-icon>{{ assetIcon }}</mat-icon>
      </div>
      <div class="dropzone-label">{{ assetLabel }}</div>
    </div>
    <input [disabled]="readOnly" type="file" #assetChooser multiple (change)="onFileSelected($event)" style="visibility:hidden" />
    <div class="thumbnail-container">
      <div class="thumbnail-grid">
        <ng-container *ngFor="let asset of assetsArray.controls; let i=index" dynamicAsset config="image" [assetType]="assetType" [current]="i"
          [group]="asset" [hideReportDefaultIcons]="hideReportDefaultIcons" (enlargeAsset)="openCarousel(i) ; openDocument(asset)" (showOnReport)="showItemOnReport(asset)" (download)="downloadItem(asset)"
          (removeAsset)="removeItem(i)" (setDefault)="setDefaultItem(asset)" [preventRemoval]="isRemovalPrevented()">
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="assetType == 'image'; else elseBlock">
    <carousel #carousel *ngIf="showCarousel" [images]="carouselImages" [showSpinner]="showSpinner" [index]="currentIndex" [loop]="true" [projectId]="projectId" [dataImages]="dataImages"
    [hideReportDefaultIcons]="hideReportDefaultIcons" [preventRemoval]="isRemovalPrevented()" [projectDepartment]="projectDepartment"
    (onSetDefault)="setDefaultItem($event)" (onShowOnReport)="showItemOnReport($event)" (onDownload)="downloadItem($event)" (onRemoveAsset)="removeItem($event)"
    (onClose)="closeCarousel($event)" (onSaveDetails)="updateImageDetails($event)" (onDeleteAnnotatedImage)="deleteAnnotatedImage($event)" (onDeleteMainImage)="deleteMainImage($event)"
    [currentCiStatus]="itemStatus" [currentCiStatusComments]="statusComments" [currentCI]="currentCI" (onCIStatusChanged)="ciStatusChange($event)"></carousel>
  </div>
  <ng-template #elseBlock>
    <image-modal id="document-modal-viewer">
      <spinner [isRunning]="showSpinner"></spinner>
      <div class="image-modal">
        <div class="modal-body">
          <object width="500" height="600" [attr.src]="largeImage"></object>
        </div>
      </div>
      <div class="modal-background"></div>
    </image-modal>
  </ng-template>
</div>
